// Force a blob-hosted template to download (instead of opening in a browser
// tab). Fetches the blob and triggers a download; falls back to opening the
// URL if the fetch is blocked (e.g. CORS) or the file is missing.
// Copied from src/components/upload/BulkUpload.tsx handleDownloadTemplate —
// BulkUpload keeps its own copy untouched.
export const downloadTemplateFromBlob = async (url: string): Promise<void> => {
  if (!url) return;
  const fileName = url.split("/").pop() || "template.xlsx";
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const blob = await res.blob();
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(objectUrl);
  } catch (err) {
    console.error("Template download failed, opening in new tab:", err);
    window.open(url, "_blank");
  }
};
